export default {
  "fr": {
    "dropzone": {
      "labels": {
        "cancelUpload": "Annuler le téléchargement",
        "cancelUploadConfirmation": "Êtes-vous sûr de vouloir annuler ce téléchargement?",
        "chooseCategory": "Cliquez pour sélectionner d'abord une catégorie",
        "defaultMessage": "Cliquez ou déposez les fichiers",
        "fallbackMessage": "Votre navigateur ne supporte pas les téléchargements de fichiers drag'n'drop.",
        "fallbackText": "Utiliser le formulaire ci-dessous pour télécharger vos fichiers comme dans les anciens jours.",
        "fileTooBig": "Le fichier est trop gros ({{filesize}} MB). Taille maximale des fichiers: {{maxFilesize}} MB.",
        "invalidFileType": "Vous ne pouvez pas télécharger des fichiers de ce type.",
        "maxFilesExceeded": "Vous ne pouvez plus télécharger de fichiers.",
        "removeFile": "Supprimer le fichier",
        "responseError": "Le serveur a répondu avec le code {{statusCode}}.",
        "uploadConfirmation": "Téléchargement confirmé",
        "warningMaxFileSize": "Jusqu'à {max_files_size} MB chacun"
      }
    }
  }
}